module.exports = __webpack_public_path__ + "static/img/saskatoon1.78e905f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/saskatoon1.jpg
// module id = 129
// module chunks = 9